import { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import {
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import dayjs from "dayjs";
import "./NamedInput.css";

const muiStyles = {
  width: "100%",

  "& .MuiSvgIcon-root": {
    color: "#F1E7D2",
  },

  "& .MuiOutlinedInput-root, &.MuiOutlinedInput-root": {
    color: "#F1E7D2",
    borderRadius: "0.5rem",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F1E7D2",
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9CF9C",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9CF9C",
      borderWidth: 2,
    },
  },

  "& .MuiInputLabel-root": {
    color: "#F1E7D2",
  },

  "& input::placeholder": {
    color: "#F1E7D2",
    opacity: 1,
  },
};

export const NamedInput = ({
  id,
  title = "",
  type = "text",
  name = "",
  required = false,
  placeholder = "",
  options = [],
}) => {
  const [value, setValue] = useState(type === "select" ? "" : null);

  return (
    <div className="named-input-container">
      <p className="named-text">
        {title} {required ? "*" : ""}
      </p>

      {type === "date" ? (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            label={placeholder}
            value={value}
            onChange={(newValue) => setValue(newValue)}
            sx={{
              width: "100%",
              '& .MuiSvgIcon-root': {
                color: "#F1E7D2",
              },
              '& .MuiFormLabel-root': {
                color: "#F1E7D2",
              },
              '& .MuiPickersInputBase-root': {
                color: "#F1E7D2",
              },
              '&.MuiPickersTextField-root': {
                '& fieldset': {
                  borderColor: '#F1E7D2',
                },
              },
              '&.MuiPickersTextField-root.Mui-focused': {
                '&.Mui-focused fieldset': {
                  borderColor: '#E9CF9C',
                },
              },
            }}
          />

          <input
            type="hidden"
            name={name}
            value={
              value
                ? dayjs(value).format(
                    "dddd, MMMM D, YYYY [at] h:mm A"
                  )
                : ""
            }
          />
        </LocalizationProvider>
      ) : type === "select" ? (
        <FormControl fullWidth>
          <Select
            displayEmpty
            value={value}
            onChange={(e) => setValue(e.target.value)}
            name={name}
            required={required}
            sx={muiStyles}
            MenuProps={{
              PaperProps: {
                sx: {
                  bgcolor: "#9B6868",
                  color: "#F1E7D2",
                },
              },
            }}
          >
            <MenuItem disabled value="">
              {placeholder}
            </MenuItem>

            {options.map((option) => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <input
          id={id}
          className="named-input"
          type={type}
          name={name}
          placeholder={placeholder}
          required={required}
        />
      )}
    </div>
  );
};

export const NamedTextArea = ({
  id,
  title = "",
  type = "text",
  name = "",
  required = false,
  placeholder = "",
}) => {
  return (
    <div className="named-input-container">
      <p className="named-text">
        {title} {required ? "*" : ""}
      </p>

      <textarea
        id={id}
        className="named-textarea"
        type={type}
        name={name}
        placeholder={placeholder}
        required={required}
        rows={4}
      />
    </div>
  );
};
